import apiClient from "../config/apiClient";


export const QueryLabRequest = async (data, prof) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=services/labs?q=${data}&hmo_id=${prof}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
